import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import image from '../../../img/other/illustration_reset_pass.png';

const styles = theme => ({
  root: {
    display: 'flex', 
    justifyContent: 'space-around', 
    alignItems: 'stretch', 
    flexFlow: 'column wrap'
  },
  item: {
    flexBasis: 'initial',
    flexGrow: 1,
    display: 'inline-flex'
  },
  buttonIndigo: theme.custom.button.indigo
})

class PasswordResetEmailSent extends React.PureComponent {

  render() {
    const { email, classes } = this.props;
    return (
      <React.Fragment>
        <Grid item xs={12} className={classes.item} style={{flexGrow: 1, alignItems: 'flex-end', justifyContent: 'center'}}>
          <Typography variant='headline'>
            Restablece tu contraseña
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.item} style={{flexGrow: 1, alignItems: 'flex-end', justifyContent: 'center'}}>
          <img src={image} />
        </Grid>
        <Grid item xs={12} className={classes.item} style={{flexGrow: 2, alignItems: 'flex-end', justifyContent: 'center'}}>
          <Typography align="center">
            Te hemos enviado un email a <strong>{email}</strong> donde encontrarás el acceso para restablecer tu contraseña.
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.item} style={{flexGrow: 1, alignItems: 'flex-end', justifyContent: 'center'}}>
          <Button type="submit" variant="contained" component={Link} to="/auth/login" className={classes.buttonIndigo}>
            OK
          </Button>
        </Grid>
      </React.Fragment>
    )
  }
}

export default withStyles(styles)(PasswordResetEmailSent);


// WEBPACK FOOTER //
// ./src/modules/auth/components/PasswordResetEmailSent.js